import React from "react";
import EnglishFlag from "@/images/flags/english.png";
import GermanyFlag from "@/images/flags/germany.png";
import { Link } from "react-router-dom";
import {
  DropdownItem,
  DropdownMenu,
  UncontrolledDropdown,
  DropdownToggle,
} from "reactstrap";

const Footer = () => {
  const buildVersion = import.meta.env.VITE_APP_BUILD_VERSION ?? "dev";

  return (
    <div className="nk-footer bg-white">
      <div className="container-fluid">
        <div className="nk-footer-wrap flex-wrap justify-content-between align-items-center">
          <div className="nk-footer-copyright text-muted small">
            &copy; {new Date().getFullYear()} AlgoReason Tech · Swiss Made 🇨🇭 · build {buildVersion}
          </div>

          <div className="nk-footer-links">
            <ul className="nav nav-sm align-items-center">
              <li className="nav-item">
                <UncontrolledDropdown direction="up">
                  <DropdownToggle
                    color="transparent"
                    className="dropdown-toggle dropdown-indicator has-indicator nav-link p-0"
                  >
                    <span>English</span>
                  </DropdownToggle>
                  <DropdownMenu end className="dropdown-menu-sm">
                    <ul className="language-list">
                      <li>
                        <DropdownItem
                          tag="a"
                          href="#english"
                          onClick={(ev) => ev.preventDefault()}
                          className="language-item"
                        >
                          <img
                            src={EnglishFlag}
                            alt="English"
                            className="language-flag"
                          />
                          <span className="language-name">English</span>
                        </DropdownItem>
                      </li>
                      <li>
                        <DropdownItem
                          tag="a"
                          href="#german"
                          onClick={(ev) => ev.preventDefault()}
                          className="language-item"
                        >
                          <img
                            src={GermanyFlag}
                            alt="Deutsch"
                            className="language-flag"
                          />
                          <span className="language-name">Deutsch</span>
                        </DropdownItem>
                      </li>
                    </ul>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </li>

              <li className="nav-item">
                <Link to="/pages/terms-policy" className="nav-link">
                  Terms
                </Link>
              </li>

              <li className="nav-item">
                <a
                  href="https://algoreason.tech/privacy-policy"
                  className="nav-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;